import { render, staticRenderFns } from "./teacherManagement.vue?vue&type=template&id=0d2690b5&scoped=true"
import script from "./teacherManagement.vue?vue&type=script&lang=js"
export * from "./teacherManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2690b5",
  null
  
)

export default component.exports